import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withRouter, Redirect } from 'react-router-dom';

import { SortDirection } from 'react-virtualized';
import { CircularProgress, Button } from 'react-md';

import Immutable from 'immutable';
import { isEqual, isEmpty } from 'lodash-es';

import { CoogTable } from '@coog/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';

import * as partiesActions from '../../Services/Parties/actions';

import FilterControls from '../../Components/Filter/FilterControls';
import {
  columns,
  filtersUI
  // statusOptions
} from './config';
import { stringifyQuery, parseQuery } from '../../Utils/Utils';
import { applyFilters } from './filters';

import './Party.scss';

class Party extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
      list: undefined,
      filteredList: undefined,
      filters: props.filters
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { list: nextList } = nextProps;
    const { list: prevList } = prevState;
    let newState = null;

    if (nextList && !!nextList.toJS && !Immutable.is(prevList, nextList)) {
      newState = {
        list: nextList // TODO: add filtering statement...
      };
    }

    return newState;
  }

  componentDidMount() {
    const self = this;
    const { actions, list, location, history, filters: defaultFilters } = self.props;
    // init data
    actions.fetchParties();
    // Init Filters
    const filters = isEmpty(parseQuery(location.search))
      ? defaultFilters
      : parseQuery(location.search);
    self.setState({ filters });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters)
    });
    if (list) {
      self.filter({ list, ref: 'componentDidMount', filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { filters: prevFilters } = prevState;
    const { list, location } = self.props;
    //
    if (!Immutable.is(prevProps.list, list)) {
      if (typeof list !== 'undefined' && !Immutable.is(prevState.list !== list)) {
        self.filter({ list, ref: 'componentDidUpdate1' });
      }
    }
    // Filters
    const filters = prevFilters || parseQuery(location.search);
    if (typeof list !== 'undefined' && filters && !isEqual(prevFilters, filters)) {
      self.setState({ filters });
      self.filter({ list, ref: 'componentDidUpdate2' });
    }
  }

  handleFiltersChange = filters => {
    const { list, history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters)
    });
    this.setState({ filters });
    this.filter({ list, ref: 'handleFiltersChange', filters });
  };

  filter = ({ list, /* ref, */ filters: newFilters }) => {
    const { filters } = this.state;
    const filteredList = applyFilters({ list, filters: newFilters || filters });
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({ filteredList });
  };

  // eslint-disable-next-line no-unused-vars
  handleGetRoute = ({ route = '', action, type, id = '' }) => {
    this.setState({
      redirect: true,
      redirectTo: `${route}${id}`
    });
  };

  handleAction = ({ route, action, type, id }) => {
    if (type === 'action') {
      switch (action) {
        default:
          break;
      }
    } else {
      this.handleGetRoute({ route, action, type, id });
    }
  };
  handleLoadMore = () => {
    const self = this;
    const { actions, currentOffset } = self.props;
    const offset = currentOffset || 0;
    actions.loadMoreParties({ offset })
  }

  render() {
    const { redirect, redirectTo, ...state } = this.state;
    if (redirect) return <Redirect push to={redirectTo} />;

    const { list, filteredList, filters } = state;
    const { pageTitle, canonical, i18n, strings } = this.props;

    const helmet = (
      <Helmet
        htmlAttributes={{
          class: 'coog',
          lang: i18n.lang
        }}
      >
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Party'}</title>
        <meta name="description" content={strings[pageTitle] || 'Party'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const parties = () =>
      list && filteredList ? (
        <MuiThemeProvider theme={theme}>
          <CoogTable
            defaultSorted={{ sortBy: 'code', sortDirection: SortDirection.DESC }}
            rows={filteredList}
            columns={columns(this.handleAction, strings)}
            strings={strings}
            uid="id"
            onClickCellAction={this.handleAction}
          />
        </MuiThemeProvider>
      ) : (
        <CircularProgress
          id="parties-loading"
          className="loading"
          scale={3}
          style={{ margin: '2em auto' }}
        />
      );

    return (
      <div className="coog-app parties">
        {helmet}
        <div className="blocks-header">
          <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || 'Tiers'}</h1>
          <div className="blocks-actions">
            {/* <Button flat primary className="icon-text-btn" iconBefore={false} iconChildren="add">Ajouter un tier</Button> */}
            {/* <Button flat primary className="text-btn">Ajouter un tier</Button> */}
            {/*
            <Button
              floating
              primary
              swapTheming
              tooltipLabel={strings['parties.actions.newpartie.btn.label'] || 'Ajouter un tier'}
              tooltipPosition="left"
              onClick={() => this.handleGetRoute({ route: '/party/new' })}
            >
              add
            </Button>
          */}
          </div>
        </div>
        {/* <Divider /> */}
        <div className="block-controls">
          {filteredList ? (
            <div className="block-info">
              <span className="value">{filteredList.size}</span>
              <span className="label">
                {strings['parties.controls.info.label'] || 'tier(s) trouvée(s)'}
              </span>
            </div>
          ) : (
            undefined
          )}
          <Button
            flat
            primary
            iconChildren="loop"
            iconBefore={true}
            // tooltipLabel={strings['parties.actions.load_more.btn.label'] || 'Charger plus'}
            // tooltipPosition="right"
            onClick={() => this.handleLoadMore()}
            id="load-more"
          >
            {strings['parties.actions.load_more.btn.label'] || 'Charger plus'}
          </Button>
          <FilterControls
            id="parties-filters-block"
            key="parties-filters-block"
            strings={strings}
            filters={filters}
            onFiltersChange={this.handleFiltersChange}
            filtersUI={filtersUI({ strings })}
          />
        </div>
        <div className="md-body md-cell md-cell--12">{parties()}</div>
      </div>
    );
  }
}

Party.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  i18n: PropTypes.shape({ lang: PropTypes.string }).isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  list: PropTypes.instanceOf(Immutable.List),
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  filters: PropTypes.object
};

Party.defaultProps = {
  pageTitle: 'title.parties.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  list: undefined,
  filters: {
    query: '',
    person: [],
    active: []
  }
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  i18n: state.toJS().system.i18n,
  list: state.getIn(['parties', 'list']),
  currentOffset: state.getIn(['parties', 'currentOffset']),
  strings: state.toJS().parties.strings
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...partiesActions }, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Party)
);
